<template>
    <v-layout>
        <div class="col-12">
            <v-toolbar flat>
                <v-toolbar-title>{{ $t('divisions_locations') }}</v-toolbar-title>
                <template v-slot:extension>
                    <v-tabs
                            v-model="tab"
                            align-with-title
                    >
                        <v-tabs-slider color="primary"></v-tabs-slider>
                        <v-tab>{{ $t('divisions') }}</v-tab>
                        <v-tab>{{$t('locations') }}</v-tab>
                    </v-tabs>
                </template>
            </v-toolbar>
            <v-tabs-items v-model="tab">
                <v-tab-item>
                    <v-card>
                        <divisions v-if="tab==0"/>
                    </v-card>
                </v-tab-item>
                <v-tab-item>
                    <v-card>
                        <locations v-if="tab==1"/>
                    </v-card>
                </v-tab-item>
            </v-tabs-items>
        </div>
    </v-layout>
</template>
<script>
    import Divisions from "./Divisions";
    import Locations from "./SALocations";
    export default {
        components: {
            divisions: Divisions,
            locations: Locations,
        },
        name: "DivisionLocations",
        data: () => ({
            loading: false,
            tab: null,
        })
    }
</script>
